"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { usePathname } from "next/navigation";
import { ContentCard } from "fansunited-sports-ui";
import { LinkPagination } from "@/components/ui/LinkPagination";
import { AuthorHeader } from "../../partials/AuthorHeader/AuthorHeader";
import { useAuthorData } from "../../context/AuthorDataContext";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { getMediaFieldUrl } from "@/utilities/media/getMediaUrl";
import type { Post } from "@/payload-types";
interface AuthorLayoutDefaultProps {
  breadcrumbs?: React.ReactNode;
}
export function AuthorLayoutDefault(t0) {
  const $ = _c(24);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    breadcrumbs
  } = t1;
  const labels = useLabels();
  const urlBuilder = useNavigation();
  const pathname = usePathname();
  const {
    author,
    posts,
    currentPage,
    totalPages,
    locale,
    headerColors
  } = useAuthorData();
  let t2;
  if ($[2] !== pathname) {
    t2 = page => {
      const params = new URLSearchParams();
      if (page > 1) {
        params.set("page", String(page));
      }
      return params.toString() ? `${pathname}?${params.toString()}` : pathname;
    };
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getPageHref = t2;
  let t3;
  if ($[4] !== locale) {
    t3 = dateString => {
      if (!dateString) {
        return "";
      }
      const date = new Date(dateString);
      return date.toLocaleDateString(locale, {
        day: "numeric",
        month: "short",
        year: "numeric"
      });
    };
    $[4] = locale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const formatDate = t3;
  const getImageUrl = _temp;
  let t4;
  if ($[6] !== author.name || $[7] !== labels.authorPage.articlesByAuthor) {
    t4 = labels.authorPage.articlesByAuthor.replace("{name}", author.name);
    $[6] = author.name;
    $[7] = labels.authorPage.articlesByAuthor;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const sectionTitle = t4;
  let t5;
  if ($[9] !== author || $[10] !== headerColors) {
    t5 = <AuthorHeader author={author} headerColors={headerColors} />;
    $[9] = author;
    $[10] = headerColors;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== currentPage || $[13] !== formatDate || $[14] !== getPageHref || $[15] !== posts || $[16] !== sectionTitle || $[17] !== totalPages || $[18] !== urlBuilder) {
    t6 = <div className="max-w-350 mx-auto px-4 md:px-6 py-8">{posts.length === 0 ? <p className="text-center text-muted-foreground py-12">{sectionTitle}: 0</p> : <><h2 className="text-2xl font-semibold mb-6">{sectionTitle}</h2><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">{posts.map(post => <ContentCard key={post.id} content={{
            id: String(post.id),
            type: "article",
            link: urlBuilder.post(post),
            title: post.title,
            description: post.summary || "",
            image: {
              url: getImageUrl(post.heroImage) || "",
              alt: post.title
            },
            metadata: {
              time: formatDate(post.publishedAt)
            }
          }} variant="standard" styles={{
            typography: {
              title: "text-lg font-semibold",
              description: "text-sm text-muted-foreground line-clamp-3"
            }
          }} />)}</div>{totalPages > 1 && <div className="mt-8 flex justify-center"><LinkPagination currentPage={currentPage} totalPages={totalPages} getPageHref={getPageHref} /></div>}</>}</div>;
    $[12] = currentPage;
    $[13] = formatDate;
    $[14] = getPageHref;
    $[15] = posts;
    $[16] = sectionTitle;
    $[17] = totalPages;
    $[18] = urlBuilder;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== breadcrumbs || $[21] !== t5 || $[22] !== t6) {
    t7 = <div className="min-h-screen">{t5}{breadcrumbs}{t6}</div>;
    $[20] = breadcrumbs;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}
function _temp(heroImage) {
  return getMediaFieldUrl(heroImage, "medium") ?? undefined;
}